/* ZipHealthy scroll reveal: safe replacement for wow.min.js
   ---------------------------------------------------------------
   Contract: this script may only ever ADD the .zh-visible class.
   Nothing here hides content. The pre-reveal hidden state lives in
   zh-reveal.css behind .zh-js, so any failure mode (no JS, blocked
   asset, thrown error, unsupported IntersectionObserver) leaves the
   page fully painted rather than blank. */
(function () {
  'use strict';

  var SELECTOR = '.wow, .zh-pre-reveal';
  var VISIBLE = 'zh-visible';

  function revealAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add(VISIBLE);
  }

  function start() {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || typeof IntersectionObserver === 'undefined') {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(VISIBLE);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);

    /* Dead-man switch: whatever the observer has not handled within 2.5s of
       load is revealed unconditionally. A slow or wedged reveal pass must
       never leave a viewport-tall white gap. */
    window.setTimeout(revealAll, 2500);
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    window.addEventListener('load', function () { window.setTimeout(revealAll, 1500); });
  } catch (e) {
    revealAll();
  }
})();
